var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"page-wrap",attrs:{"id":"page-wrap"}},[_c('div',{staticClass:"container-fluid"},[_c('header-menu'),_c('router-view')],1),_c('div',{staticClass:"push"})]),_c('footer-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }